import { createPinia } from 'pinia'
import { useMainStore } from './main'
// 引入持久化插件
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia();

// 使用该插件
pinia.use(piniaPluginPersistedstate)

// 统一导出useStore方法
export const useStore = () => {
  return {
    main: useMainStore(),
  }
}
//导出
export default pinia;